import React, { useEffect, useRef } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import blogData from "../../../_data/blogData";
import ShareLinks from "../../../components/Blogs/ShareLinks";
import { PiArrowUpRightDuotone } from "react-icons/pi";
import { Helmet } from "react-helmet";

const SingleBlogPage = () => {
    const { slug } = useParams();
    const location = useLocation();
    const blog = blogData.find((b) => b.slug === slug);

    // Generate blog URL from current URL path
    const blogUrl = `${window.location.origin}${location.pathname}`;

    // META TAGS
    const metaTitle = blog ? `${blog.title}` : "Insight Not Found | DODEAL";
    const metaDescription = blog ? `${blog.description}` : "Explore DODEAL's insights on the latest marketing and software trends and insights.";
    const metaKeywords = blog ? `${blog.keyword}` : "dodeal, do deal, marketing, seo, digital, advertising, campaigns, real estate, blog, insight, trend";

    const otherBlogs = blogData.filter((b) => b.slug !== slug);
    const randomBlogs = otherBlogs
        .sort(() => Math.random() - 0.5)
        .slice(0, 6);

    useEffect(() => {
        // Scroll to top on slug change to ensure content is visible
        window.scrollTo(0, 0);
    }, [slug]);

    return (
        <>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={metaKeywords} />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta name="twitter:card" content="summary_large_image" />
                <link rel="canonical" href={blogUrl} />
            </Helmet>
            {blog ? (
                <img
                    src={blog.image}
                    alt={blog.keyword || blog.title}
                    className="w-full h-[40vh] lg:h-[70vh] object-cover"
                    style={{ zIndex: 0 }}
                />
            ) : (
                <div
                    className="w-full h-[40vh] lg:h-[70vh] flex items-center justify-center"
                    style={{ zIndex: 0 }}
                >
                    <div class="glitch" data-text="404">404</div>
                </div>
            )}
            <div className="relative padding-container">
                <div
                    className="relative bg-white rounded-xl lg:mx-16 p-6 lg:p-10 lg:px-16 !text-black lg:text-justify mt-[-10vh] flex flex-col gap-6"
                    style={{ zIndex: 1 }}
                >
                    {blog ? (
                        <>
                            <p className="text-center uppercase">
                                {blog.keyword}
                            </p>
                            <h1 className="text-center text-xl md:text-2xl lg:text-3xl font-bold text-[var(--primary)]">
                                {blog.title}
                            </h1>
                            <div className="flex flex-col lg:flex-row gap-5">
                                <div className="relative w-full justify-center flex lg:w-fit">
                                    <ShareLinks blogUrl={blogUrl} blogTitle={blog.title} />
                                </div>
                                <div className="flex flex-col gap-5">
                                    <div className="rounded-xl flex items-center justify-center p-5"
                                        style={{
                                            background:
                                                "linear-gradient(149.54deg, rgba(211, 211, 211, 0.4) 22.72%, rgba(255, 255, 255, 0.7) 115.21%)",
                                        }}
                                    >
                                        <p className="text-xs md:text-sm">
                                            {blog.description}
                                        </p>
                                    </div>
                                    <div
                                        className="prose max-w-none flex flex-col gap-6 blog py-5"
                                        dangerouslySetInnerHTML={{ __html: blog.content }}
                                    ></div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="flex items-center justify-center py-5">
                            The content might be removed!
                        </div>
                    )}
                </div>
            </div>
            <div className="relative py-5 my-5 flex flex-col gap-4">
                <h4 className="padding-container lg:mx-16 flex items-center justify-between text-xl uppercase pt-5 mt-5">
                    <span>More</span>
                    <Link
                        to="/blogs"
                        className="w-fit text-white hover:text-[var(--primary)] transition-all duration-300 bg-white/20 p-2 rounded-full backdrop-blur-sm"
                    >
                        <PiArrowUpRightDuotone size={22} />
                    </Link>
                </h4>
                <div
                    className="w-full overflow-x-auto overflow-y-hidden"
                    style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch", msOverflowStyle: "none" }}
                >
                    <div className="flex gap-5" style={{ width: "fit-content" }}>
                        {randomBlogs.length > 0 && (
                            randomBlogs.map((otherBlog, i) => (
                                <Link
                                    key={otherBlog.id}
                                    className={`${i === 0 ? "lg:pl-[7%]" : ""} ${i === randomBlogs.length - 1 ? "lg:pr-[7%]" : ""} cursor-pointer flex-shrink-0`}
                                    to={`/blogs/${otherBlog.slug}`}
                                >
                                    <div
                                        className="relative w-[300px] h-[350px] rounded-xl flex flex-col justify-end"
                                        style={{ backgroundImage: `url("${otherBlog.image}")`, backgroundSize: "cover", backgroundPosition: "center" }}
                                    >
                                        <div className="absolute w-full h-full rounded-xl" style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #000000 100%)", mixBlendMode: "multiply" }}></div>
                                        <div className="absolute w-full h-full rounded-xl flex flex-col p-4 justify-end" style={{ zIndex: 1 }}>
                                            <div className="font-bold uppercase">{otherBlog.title}</div>
                                        </div>
                                    </div>
                                </Link>
                            ))
                        )}
                    </div>
                </div>
            </div>
            {/* <div className="grid grid-cols-3 lg:grid-cols-4 gap-5">
                    <div className="flex flex-col gap-10 col-span-3">
                        {blog ? (
                            <>
                                <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-[var(--primary)]">
                                    {blog.title}
                                </h1>
                                <img
                                    src={blog.image}
                                    alt={blog.keyword || blog.title}
                                    className="w-full h-96 object-cover rounded-[32px]"
                                />
                                <div className="flex gap-5">
                                    <div className="flex flex-col w-fit gap-2">
                                        <ShareLinks blogUrl={blogUrl} blogTitle={blog.title} />
                                    </div>
                                    <div className="flex flex-col gap-5">
                                        <div className="rounded-xl flex items-center justify-center p-5"
                                            style={{
                                                background:
                                                    "linear-gradient(149.54deg, rgba(211, 211, 211, 0.2) 22.72%, rgba(255, 255, 255, 0.5) 115.21%)",
                                            }}
                                        >
                                            <p className="text-xs md:text-sm">
                                                {blog.description}
                                            </p>
                                        </div>
                                        <div
                                            className="prose max-w-none flex flex-col gap-6 blog py-5"
                                            dangerouslySetInnerHTML={{ __html: blog.content }}
                                        ></div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>404 Not found</>
                        )}
                    </div>
                    <div className="flex flex-col gap-5">
                        {randomBlogs.length > 0 ? (
                            randomBlogs.map((otherBlog) => (
                                <Link
                                    key={otherBlog.id}
                                    to={`/blogs/${otherBlog.slug}`}
                                    className="flex flex-col gap-3 p-4 rounded-[16px] hover:bg-[var(--primary)] hover:text-white transition-all duration-300"
                                    style={{
                                        background:
                                            "linear-gradient(149.54deg, rgba(211, 211, 211, 0.2) 22.72%, rgba(255, 255, 255, 0.5) 115.21%)",
                                    }}
                                >
                                    <img
                                        src={otherBlog.image}
                                        alt={otherBlog.keyword || otherBlog.title}
                                        className="w-full h-32 object-cover rounded-[8px]"
                                    />
                                    <h3 className="text-sm md:text-base font-semibold">
                                        {otherBlog.title}
                                    </h3>
                                    <p className="text-xs md:text-sm line-clamp-2">
                                        {otherBlog.description}
                                    </p>
                                </Link>
                            ))
                        ) : (
                            <p className="text-sm text-[var(--primary)]">
                                No other blogs available.
                            </p>
                        )}
                        <Link
                            to="/blogs"
                            className="mt-4 inline-block text-center text-sm md:text-base font-semibold py-2 px-4 rounded-[16px] bg-[var(--primary)] text-white hover:bg-[var(--secondary)] hover:text-[var(--primary)] transition-all duration-300"
                        >
                            More Blogs
                        </Link>
                    </div>
                </div> */}
            <div className="h-[50px]"></div>
        </>
    );
};

export default SingleBlogPage;